module.exports = __webpack_public_path__ + "media/images/lp_consultation/agency-step02-ba3fa151e05b7e8a3e0393d76929fe6d.jpg";